export const TuvisSettingsDataLayerSymbol = Symbol.for("TuvisSettingsDataLayer");
